import { createOrder } from './order/create-order';
import { getOrderStatus } from './order/get-order-status';
import { getCustomer } from './subscription/get-customer';
import {
  getConfigurationsFromCountryCode,
  getConfigurationsFromCustomerId,
} from './payment-page-configuration/get-payment-page-configuration';
import {
  previewSubscriptionAmendmentCosts,
  previewSubscriptionCreationCosts,
  previewSubscriptionReactivationCosts,
} from './preview-cost-changes/preview-cost-changes';
import { getSubscriptionInfo } from './subscription/get-subscription-info';
import { getCustomerSummary } from './subscription/getCustomerSummary';
import { updateCustomerEmailAddresses } from './subscription/update-customer-email-addresses';
import { getCustomerEmailAddresses } from './subscription/get-customer-email-addresses';
import { cancelSubscription } from './order/cancel-subscription';
import { amendOrder } from './order/amend-order';
import { updatePaymentMethod } from './order/update-payment-method';
import { reactivateOrder } from './order/reactivate-order';
import { updateCustomerDetails } from './order/update-customer-details';

export const previewApi = {
  subscriptionCreationCosts: previewSubscriptionCreationCosts,
  subscriptionAmendmentCosts: previewSubscriptionAmendmentCosts,
  subscriptionReactivationCosts: previewSubscriptionReactivationCosts,
};

export const zuoraApi = {
  getConfigurationsFromCountryCode,
  getConfigurationsFromCustomerId,
};

export const customerOrderApi = {
  getOrderStatus,
  createOrder,
  amendOrder,
  reactivateOrder,
};

export const subscriptionApi = {
  getSubscriptionInfo,
  getCustomerSummary,
  cancelSubscription,
  getCustomer,
  updatePaymentMethod,
  updateCustomerDetails,
  updateCustomerEmailAddresses,
  getCustomerEmailAddresses,
};

export type { User, SubscriptionInfo } from './subscription/model';

export type { CostSummaryDto } from './common/dto/cost';

export type { CustomerSummary } from './common/model/customer-summary';

export type { PreviewCostsResponse } from './preview-cost-changes/model';

export { registerApiMocks } from './mocks';
